(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  // A "more" link only where a review is actually cut off.
  const init = () => {
    document.querySelectorAll('.greview').forEach((card) => {
      const text = card.querySelector('[data-review-text]');
      const more = card.querySelector('[data-review-more]');
      if (!text || !more) return;
      if (!card.classList.contains('is-open')) more.hidden = text.scrollHeight <= text.clientHeight + 2;
      more.onclick = () => {
        const open = card.classList.toggle('is-open');
        more.textContent = open ? more.dataset.less : more.dataset.more;
      };
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
